function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { connect, useSelector } from 'react-redux';
import { cmsActions } from '../../reducers/cms.reducer';
import cropRatio from '../../helpers/cropRatio';
import ReactCrop from 'react-image-crop';
// import 'react-image-crop/lib/ReactCrop.scss';

import Button from './Button.react';
var Cropper = function Cropper(_ref) {
  var visible = _ref.visible,
    onClose = _ref.onClose,
    onCrop = _ref.onCrop,
    _ref$asset = _ref.asset,
    pAsset = _ref$asset === void 0 ? null : _ref$asset,
    _ref$assetID = _ref.assetID,
    pAssetID = _ref$assetID === void 0 ? null : _ref$assetID,
    assetsAction = _ref.assetsAction,
    type = _ref.type;
  var assets = useSelector(function (s) {
    var _s$cms;
    return ((_s$cms = s.cms) === null || _s$cms === void 0 ? void 0 : _s$cms.assets) || {};
  });
  var bucket = useSelector(function (s) {
    return s.config.bucket;
  });
  var _useState = useState(uuid()),
    _useState2 = _slicedToArray(_useState, 1),
    id = _useState2[0];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    asset = _useState4[0],
    setAsset = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    loading = _useState6[0],
    setLoading = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    count = _useState8[0],
    setCount = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    error = _useState0[0],
    setError = _useState0[1];
  var _useState1 = useState({
      aspect: 1400 / 380
    }),
    _useState10 = _slicedToArray(_useState1, 2),
    crop = _useState10[0],
    setCrop = _useState10[1];
  useEffect(function () {
    assetsAction({});
    return function () {
      $('body').css({
        overflowY: 'scroll'
      });
    };
  }, []);
  useEffect(function () {
    $('body').css({
      overflowY: visible ? 'hidden' : 'scroll'
    });
  }, [visible]);
  useEffect(function () {
    setCount(0);
    setLoading(true);
    setError(false);
    if (pAsset) setAsset(pAsset);
    if (pAssetID) setAsset(assets[pAssetID]);
  }, [assets, pAsset, pAssetID]);
  useEffect(function () {
    if (!asset) return;
    loadImage({
      filename: "".concat((asset === null || asset === void 0 ? void 0 : asset.filename) || null)
    });
  }, [asset]);
  useEffect(function () {
    if (count === 3) setError(true);else {
      setTimeout(function () {
        loadImage({
          filename: "".concat((asset === null || asset === void 0 ? void 0 : asset.filename) || null)
        });
      }, 1000 + count * 1000);
    }
  }, [count]);
  var loadImage = function loadImage(_ref2) {
    var filename = _ref2.filename;
    if (filename == 'null') return;
    var img = new window.Image();
    img.onload = function () {
      setLoading(false);
    };
    img.onerror = function () {
      setCount(count + 1);
    };
    img.src = "".concat(bucket, "/").concat(filename);
  };
  var handleOnCrop = function handleOnCrop() {
    var tmp = _objectSpread({}, crop);
    if ('x' in tmp) tmp.x = parseFloat((tmp.x / 100).toFixed(2));
    if ('y' in tmp) tmp.y = parseFloat((tmp.y / 100).toFixed(2));
    if ('width' in tmp) tmp.width = parseFloat((tmp.width / 100).toFixed(2));
    if ('height' in tmp) tmp.height = parseFloat((tmp.height / 100).toFixed(2));
    onCrop({
      crop: tmp,
      assetID: asset === null || asset === void 0 ? void 0 : asset._id
    });
    setCrop({
      aspect: crop.aspect
    });
  };
  useEffect(function () {
    setCrop(_objectSpread(_objectSpread({}, crop), {}, {
      aspect: cropRatio(type) || 1400 / 288
    }));
  }, [type]);
  var isValid = function isValid() {
    return (crop === null || crop === void 0 ? void 0 : crop.width) > 1 && (crop === null || crop === void 0 ? void 0 : crop.height) > 1;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, visible && /*#__PURE__*/createPortal(/*#__PURE__*/React.createElement("div", {
    className: "cropper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cropper__bg"
  }), /*#__PURE__*/React.createElement("div", {
    className: "cropper__body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cropper__area"
  }, asset && /*#__PURE__*/React.createElement(ReactCrop, {
    src: "".concat(bucket, "/").concat(asset === null || asset === void 0 ? void 0 : asset.filename),
    crop: crop,
    onChange: function onChange(newCrop, newPerc) {
      setCrop(newPerc);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "cropper__controls"
  }, /*#__PURE__*/React.createElement(Button, {
    label: "Close",
    type: "cancel",
    onClick: function onClick() {
      return onClose();
    }
  }), /*#__PURE__*/React.createElement(Button, {
    label: "Crop",
    disabled: !isValid(),
    onClick: function onClick() {
      handleOnCrop();
      onClose();
    }
  })))), document.getElementById('root')));
};
var mdtp = {
  assetsAction: cmsActions.assets
};
export default connect(null, mdtp)(Cropper);